import BaseModel from '@/models/base';

export default class Session extends BaseModel {
  static entity = 'sessions';
  static apiPath = 'sessions';
  static routeName = 'session';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(''),
      date: this.date(null),
      publishing_datetime: this.date(null),
      agenda_id: this.attr(null),
      protocol_id: this.attr(null),
      businesses: this.attr([]),
      businessesRelation: this.hasManyBy('businesses', 'businesses'),
      is_published: this.boolean(false),
      delete_agenda: this.boolean(false),
      delete_protocol: this.boolean(false),
    };
  }

  get agenda() {
    if (!this.agenda_id) { return null; }

    return this.constructor.relation('files').find(this.agenda_id);
  }

  get protocol() {
    if (!this.protocol_id) { return null; }

    return this.constructor.relation('files').find(this.protocol_id);
  }
}
